import fp from 'lodash/fp';

import { modelSelector, websocketStatusSelector } from 'redux/api/selectors';
import { API_PENDING, API_SUCCESS } from 'redux/api/constants';

// ------------------------------------
// Attendance module selectors
// ------------------------------------
export const blocksSelector = modelSelector('blocks', []);
export const blockReportSelector = modelSelector('blockReport', []);
export const contactAttendanceSelector = modelSelector('contactAttendance', {
	attendance: [],
});
export const scheduleStatsSelector = modelSelector('scheduleStats', []);
export const schedulesSelector = modelSelector('schedules', []);
export const overrideAttendanceResultSelector = modelSelector(
	'overrideAttendanceResult',
	{},
);
export const contactScheduleReportSelector = modelSelector(
	'contactScheduleReport',
	[],
);
export const lowAttendanceReportSelector = modelSelector(
	'lowAttendanceReport',
	{},
);
export const lowAttendanceReportStatusSelector = websocketStatusSelector(
	'lowAttendanceReport',
);
export const holderSchedulesSelector = modelSelector('holderSchedules', []);
export const holderSchedulesAssignmentsSelector = modelSelector(
	'holderSchedulesAssignments',
	{},
);
export const scheduleHoldersAssignmentsSelector = modelSelector(
	'scheduleHoldersAssignments',
	{},
);
export const blockDetailsSelector = modelSelector('blockDetails', null);
export const scheduleDetailsSelector = modelSelector('scheduleDetails', {});
export const blockAttendanceByHolderSelector = modelSelector(
	'blockAttendanceByHolder',
	[],
);
export const accumulatedBlockAttendanceByHolderSelector = modelSelector(
	'accumulatedBlockAttendanceByHolder',
	{},
);

// ------------------------------------
// Agent module selectors
// ------------------------------------
export const agentsSelector = modelSelector('agentList', []);

// ------------------------------------
// Camera module selectors
// ------------------------------------
export const camerasSelector = modelSelector('cameraList', []);
export const cameraDetailsSelector = modelSelector('cameraDetails', null);
export const cameraDetailsStatusSelector = websocketStatusSelector('cameraDetails',);

// ------------------------------------
// Client Config module selectors
// ------------------------------------
export const clientConfigSelector = modelSelector('clientConfigList', []);
export const clientConfigDetailsSelector = modelSelector('clientConfigDetail', null);
export const clientConfigDetailsStatusSelector = websocketStatusSelector(
	'clientConfigDetail',
);

// ------------------------------------
// Doorflow Client Config module selectors
// ------------------------------------
export const doorflowClientConfigDetailsSelector = modelSelector('doorflowClientConfigDetail', null);
export const doorflowClientConfigDetailsStatusSelector = websocketStatusSelector(
	'doorflowClientConfigDetail',
);

// ------------------------------------
// Client module selectors
// ------------------------------------
export const clientsSelector = modelSelector('clientList', []);
export const currentClientSelector = modelSelector('clientDetail');
export const currentClientStatusSelector = websocketStatusSelector(
	'clientDetail',
);
export const clientIsLoadingSelector = fp.compose(
	status => status === 'INIT' || status === API_PENDING,
	currentClientStatusSelector,
);
export const holderIsLoadingSelector = ({ websocket }) => {
	if (websocket) {
		return websocket.holderDetails !== 'unifi.API_REQUEST_SUCCESS';
	}
};
export const holderListIsLoadingSelector = ({ websocket }) => {
	if (websocket) {
		return websocket.holdersList !== 'unifi.API_REQUEST_SUCCESS';
	}
};
export const detectablesStudentsListIsLoadingSelector = ({ websocket }) => {
	if (websocket) {
		return websocket.contactAttendance !== 'unifi.API_REQUEST_SUCCESS';
	}
};
export const detectablesSheduleStatsLoadingSelector = ({ websocket }) => {
	if (websocket) {
		return websocket.scheduleStats !== 'unifi.API_REQUEST_SUCCESS';
	}
};
export const detectablesSheduleDetailsLoadingSelector = ({ websocket }) => {
	if (websocket) {
		return websocket.scheduleDetails !== 'unifi.API_REQUEST_SUCCESS';
	}
};
export const detectablesSheduleBlockLoadingSelector = ({ websocket }) => {
	if (websocket) {
		return websocket.blocks !== 'unifi.API_REQUEST_SUCCESS';
	}
};
export const detectablesBlockDetailsLoadingSelector = ({ websocket }) => {
	if (websocket) {
		return websocket.blockDetails !== 'unifi.API_REQUEST_SUCCESS';
	}
};
export const detAttBlockByHolderLoadingSelector = ({ websocket }) => {
	if (websocket) {
		return (
			websocket.blockAttendanceByHolder !== 'unifi.API_REQUEST_SUCCESS'
		);
	}
};
export const detectablesBlockReportLoadingSelector = ({ websocket }) => {
	if (websocket) {
		return websocket.blockReport !== 'unifi.API_REQUEST_SUCCESS';
	}
};
export const clientIsLoadedSelector = fp.compose(
	fp.isEqual(API_SUCCESS),
	currentClientStatusSelector,
);

// ------------------------------------
// Detectables module selectors
// ------------------------------------
export const detectablesListSelector = modelSelector('detectablesList', []);

// ------------------------------------
// Holder module selectors
// ------------------------------------
export const holdersSelector = modelSelector('holdersList', []);
export const holdersCountSelector = modelSelector('holdersCountList', []);
export const holderDetailsSelector = modelSelector('holderDetails', null);
export const holdersCacheSelector = modelSelector('holdersCache', {});
export const programmesSelector = modelSelector('programmesList', []);

// ------------------------------------
// Operator module selectors
// ------------------------------------
export const operatorListSelector = modelSelector('operatorList', []);
export const operatorListStatusSelector = websocketStatusSelector(
	'operatorList',
);
export const operatorDetailsSelector = modelSelector('operatorDetails', null);
export const operatorDetailsStatusSelector = websocketStatusSelector(
	'operatorDetails',
);
export const operatorSiteDetailsSelector = modelSelector('operatorSiteDetails', null);
export const operatorSiteDetailsStatusSelector = websocketStatusSelector(
	'operatorSiteDetails',
);
export const operatorTabDetailsSelector = modelSelector('operatorTabDetails', null);
export const operatorTabDetailsStatusSelector = websocketStatusSelector(
	'operatorTabDetails',
);
export const qlikTicketSelector = modelSelector('qlikTicket', "");
export const qlikUserSelector = modelSelector('qlikUser', false);

// ------------------------------------
// Live Visits module selectors
// ------------------------------------
export const liveVisitListSelector = modelSelector('livevisitList', []);
export const liveVisitHoldersCountSelector = modelSelector('liveVisitHoldersCountList', 0);
export const liveVisitHoldersOnSiteCountSelector = modelSelector('liveVisitHoldersOnSiteCountList', 0);
export const faceCheckinsSelector = modelSelector('facecheckinsList', []);
export const liveVisitListStatusSelector = websocketStatusSelector(
	'livevisitList',
);
export const liveVisitListDateSelector = modelSelector('livevisitListDate', []);
export const liveVisitListDateStatusSelector = websocketStatusSelector(
	'livevisitListDate',
);

// ------------------------------------
// Site module selectors
// ------------------------------------
export const siteListSelector = modelSelector('sitesList', []);
export const siteSelector = modelSelector('sitesList[0]', null);
export const siteIdSelector = fp.compose(
	fp.get('siteId'),
	siteSelector,
);
export const zonesInfoSelector = modelSelector('zonesInfo', []);
export const zonesCheckinCheckoutInfoSelector = modelSelector('zonesCheckinCheckoutInfo', []);
export const allZonesInfoSelector = modelSelector('allZonesList', []);
export const zoneDetailsSelector = modelSelector('zoneDetails', null);
export const zoneDetailsStatusSelector = websocketStatusSelector(
	'zoneDetails',
);
export const allReadersInfoSelector = modelSelector('allReadersList', []);
export const allAntennasInfoSelector = modelSelector('allAntennasList', []);
export const readerDetailsSelector = modelSelector('readerDetails', null);
export const readerDetailsStatusSelector = websocketStatusSelector(
	'readerDetails',
);
export const liveDiscoverySelector = modelSelector('liveDiscovery', []);
export const liveThermalDiscoverySelector = modelSelector(
	'liveThermalDiscovery',
	[],
);
export const liveSecurityMessagingSelector = modelSelector(
	'securityMessaging',
	[],
);
export const liveFaceDiscoverySelector = modelSelector(
	'liveFaceDiscovery',
	[],
);
export const liveWifiDiscoverySelector = modelSelector('liveWifiDiscovery', null);
export const siteDetailsSelector = modelSelector('siteDetails', null);
export const siteDetailsStatusSelector = websocketStatusSelector(
	'siteDetails',
);
export const sitesInfoSelector = modelSelector('sitesList', []);
export const allSitesInfoSelector = modelSelector('allSitesList', []);
export const allProfilesInfoSelector = modelSelector('allProfilesList', []);
export const accumulatedZonesBySiteSelector = modelSelector(
	'accumulatedZonesBySite',
	{},
);

// ------------------------------------
// User module selectors
// ------------------------------------
export const userSelector = fp.get('user');
export const currentUserSelector = fp.compose(
	fp.get('currentUser'),
	userSelector,
);
export const loginStatusSelector = fp.compose(
	fp.get('isLoggingIn'),
	userSelector,
);
export const verticalConfigSelector = fp.compose(
	fp.get('verticalConfig'),
	currentUserSelector,
);
export const attendanceEnabledSelector = fp.compose(
	Boolean,
	fp.get('attendance'),
	verticalConfigSelector,
);
export const liveViewEnabledSelector = fp.compose(
	fp.get('core.liveViewEnabled'),
	verticalConfigSelector,
);
export const passwordResetInfoSelector = modelSelector('passwordResetInfo');
export const passwordResetInfoStatusSelector = websocketStatusSelector(
	'passwordResetInfo',
);
export const setPasswordStatusSelector = websocketStatusSelector('setPassword');
export const requestPasswordResetStatusSelector = websocketStatusSelector(
	'requestPasswordReset',
);
export const cancelPasswordResetStatusSelector = websocketStatusSelector(
	'cancelPasswordReset',
);
export const changePasswordStatusSelector = websocketStatusSelector(
  'changePassword',
);
export const mfaSettingsSelector = websocketStatusSelector(
  'mfaSettings',
);



// WEBPACK FOOTER //
// ./src/redux/selectors.js